var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileCopy = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 2.625V5.6C13.125 6.09005 13.125 6.33507 13.2204 6.52224C13.3043 6.68688 13.4381 6.82074 13.6028 6.90463C13.7899 7 14.035 7 14.525 7H17.5M8.75 7H5.25C4.2835 7 3.5 7.7835 3.5 8.75V16.625C3.5 17.5915 4.2835 18.375 5.25 18.375H10.5C11.4665 18.375 12.25 17.5915 12.25 16.625V14M14 2.625H11.55C10.5699 2.625 10.0799 2.625 9.70552 2.81574C9.37623 2.98352 9.10852 3.25123 8.94074 3.58052C8.75 3.95486 8.75 4.44491 8.75 5.425V11.2C8.75 12.1801 8.75 12.6701 8.94074 13.0445C9.10852 13.3738 9.37623 13.6415 9.70552 13.8093C10.0799 14 10.5699 14 11.55 14H14.7C15.6801 14 16.1701 14 16.5445 13.8093C16.8738 13.6415 17.1415 13.3738 17.3093 13.0445C17.5 12.6701 17.5 12.1801 17.5 11.2V6.125L14 2.625Z",
  strokeWidth: 2,
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileCopy);
export default ForwardRef;